// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".certiPopWrap[data-v-5caf49ca]{width:80%;left:10%;position:fixed;z-index:999;top:30%;min-height:220px;box-shadow:0 0 9px 2px #b8b8b8;max-height:500px;max-height:250px;padding:20px;border-radius:10px;background:#fff}", ""]);
// Exports
module.exports = exports;
